export const connectors = {
  zentrumhub: 'zentrumhub',
  booking: 'booking',
  expedia: 'expedia'
};
